import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Phase 3 route guard: renders children only when the authenticated user is
 * an active super_admin. Otherwise redirects to "/" (Dashboard).
 *
 * NOTE: This is a client-side convenience guard. The backend admin endpoints
 * are independently protected by `require_super_admin` — never trust this
 * guard for security.
 */
export default function RequireSuperAdmin({ children }) {
  const { user, loading, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
